module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot3-2560x1440.512429d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot3-2560x1440.jpg
// module id = 1071
// module chunks = 37